// extracted by mini-css-extract-plugin
export var aiStarIcon = "_lu-2";
export var container = "_lu-4";
export var dismissButton = "_lu-3";
export var hasPaddingBottom = "_lu-6";
export var last = "_lu-e";
export var scrollbarThumb = "_lu-c";
export var scrollbarTrack = "_lu-b";
export var selected = "_lu-9";
export var spin = "_lu-1";
export var spinning = "_lu-0";
export var suggestionItem = "_lu-d";
export var suggestionsPanel = "_lu-5";
export var tonePill = "_lu-8";
export var tonesContainer = "_lu-7";
export var unselected = "_lu-a";